/**
 * MVP: Gerçek koordinat yok; il/ilçe + iki kullanıcı kimliğinden deterministik
 * "mesafe hissi" üretir. Üretimde grid/sunucu tarafı konum tercih edilmelidir.
 */

function simpleHash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

function capitalizeDistrict(name: string): string {
  const t = name.trim();
  if (!t) {
    return '';
  }
  return t.charAt(0).toLocaleUpperCase('tr-TR') + t.slice(1).toLocaleLowerCase('tr-TR');
}

/**
 * Örn: "Çankaya civarında, sana ~3 km uzaklıkta"
 * @param city İl (şu an metinde kullanılmıyor; ileride bölge metni için saklı)
 * @param district İlçe (metinde gösterilir)
 * @param viewerUserId Görüntüleyen kullanıcı
 * @param otherUserId Karşı kullanıcı (deterministik km için)
 */
export function formatFuzzyProximityLabel(
  city: string,
  district: string,
  viewerUserId: string,
  otherUserId: string,
): string {
  void city;
  const seed = simpleHash(`${viewerUserId}|${otherUserId}|${district.trim()}|${city.trim()}`);
  const km = 2 + (seed % 7);
  const d = capitalizeDistrict(district) || 'Bu bölge';
  return `${d} civarında, sana ~${km} km uzaklıkta`;
}

/** @deprecated Yerine formatFuzzyProximityLabel kullanın */
export function fuzzyDistanceKmLabel(userIdA: string, userIdB: string): string {
  return formatFuzzyProximityLabel('', '', userIdA, userIdB);
}
